const swiperOptionsIndex = {
  loop: true,
  slidesPerView: "auto",
  spaceBetween: 20,
  centeredSlides: true,
  // Navigation arrows
  navigation: {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next"
  },
  breakpoints: {
    768: {
      allowTouchMove: false,
      centeredSlides: false
    }
  },
  on: {
    slideChange: (swiper) => {
      const productVideos = document.querySelectorAll(".js-productVideo");
      const activeVideo = document.querySelector(`#js-productVideo${swiper.realIndex + 1}`);
      activeVideo.play();
      productVideos.forEach((element) => {
        if (activeVideo.getAttribute("id") != element.getAttribute("id")) {
          element.pause();
        }
      });
    }
  }
};
const swiperOptionsProduct = {
  loop: false,
  slidesPerView: "auto",
  spaceBetween: 30,
  centeredSlides: true,
  // Navigation arrows
  navigation: {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next"
  },
  breakpoints: {
    768: {
      allowTouchMove: false
    }
  },
  on: {
    slideChange: (swiper) => {
      const productVideos = document.querySelectorAll(".js-productVideo");
      const activeVideo = document.querySelector(`#js-productVideo${swiper.realIndex + 1}`);
      activeVideo.play();
      productVideos.forEach((element) => {
        if (activeVideo.getAttribute("id") != element.getAttribute("id")) {
          element.pause();
        }
      });
    }
  }
};
document.addEventListener("DOMContentLoaded", function() {
  const videoGallery = document.getElementById("js-productVideoGallery");
  if (videoGallery) {
    if (location.pathname.includes("products")) {
      new Swiper("#js-productVideoGallery", swiperOptionsProduct);
    } else {
      new Swiper("#js-productVideoGallery", swiperOptionsIndex);
    }
  }
}, false);
{
  const productCards = document.getElementsByClassName("js-productCard");
  window.addEventListener("DOMContentLoaded", function() {
    for (let i = 0; i < productCards.length; i++) {
      const productCard = productCards[i];
      const handle = productCard.dataset.handle;
      fetch(`/products/${handle}.js`).then((response) => response.json()).then((data) => {
        console.log({ data });
        const featuredImage = data.featured_image;
        const title = data.title;
        const price = data.price / 100;
        const url = data.url;
        const dom = `
            <a href="${url}" class="product-card__box">
              <div class="product-card__img">
                <div class="product-card__img-inner">
                  <img src="${featuredImage}" class="Image--LazyLoad" width="130px" height="130px">
                </div>
              </div>
              <div class="product-card__body">
                <div class="product-card__body-inner">
                  <p class="product-card__title line-clamp line-clamp--1">${title}</p>
                  <div class="product-card__price">販売価格：<span class="price">${price.toLocaleString()}円</span></div>
                </div>
                <div class="product-card__link-wrapper">
                  <span href="${url}" class="button Button Button--primary product-card__link">詳細を見る</span>
                </div>
              </div>
            </a>
          `;
        productCard.insertAdjacentHTML("beforeend", dom);
      }).catch((error) => console.error("Error: ", error));
    }
  });
}
{
  const addToCart = document.getElementById("js-AddToCart");
  const fakeAddToCartSm = document.getElementById("js-fakeAddToCartSm");
  if (fakeAddToCartSm) {
    fakeAddToCartSm.addEventListener("click", function() {
      const event = new Event("click", { "bubbles": true, "cancelable": false });
      addToCart.dispatchEvent(event);
    });
    const productSummary = document.getElementById("js-productSummary");
    if (productSummary) {
      window.addEventListener("scroll", function() {
        const position = productSummary.getBoundingClientRect().top;
        if (position <= window.innerHeight) {
          fakeAddToCartSm.classList.add("is-show");
        } else {
          if (fakeAddToCartSm.classList.contains("is-show")) {
            fakeAddToCartSm.classList.remove("is-show");
          }
        }
      });
    } else {
      fakeAddToCartSm.classList.add("is-show");
    }
  }
}
{
  const tableContents = document.getElementById("js-tableContents");
  if (tableContents) {
    document.addEventListener("DOMContentLoaded", function() {
      const outlineDom = `
        <div class="Collapsible">
          <button class="Collapsible__Button table-contents__title" data-action="toggle-collapsible" aria-expanded="false">目次 <span class="table-content__title-sub"></span></button>
          <div class="Collapsible__Inner">
            <div class="Collapsible__Content">
              <ul id="js-tableContentsList" class="table-contents__list">
              </ul>
            </div>
          </div
        </div>
      `;
      tableContents.insertAdjacentHTML("beforeend", outlineDom);
      const articleBody = document.getElementById("js-articleBody");
      const h2 = articleBody.querySelectorAll("h2");
      const tableContentsList = document.getElementById("js-tableContentsList");
      h2.forEach((e, i) => {
        e.setAttribute("id", i);
        const dom = `
          <li class="table-contents__item"><a href="#${i}">${e.innerText}</a></li>
        `;
        tableContentsList.insertAdjacentHTML("beforeend", dom);
      });
    }, false);
  }
}
document.addEventListener("DOMContentLoaded", linkWithinPageControl, false);
function linkWithinPageControl() {
  const scrollLink = document.querySelectorAll('a[href^="#"]');
  if (scrollLink !== null) {
    for (let i = 0; i < scrollLink.length; i++) {
      scrollLink[i].addEventListener("click", scrollToAnchor.bind(scrollLink[i]), false);
    }
  }
}
function scrollToAnchor(e) {
  const HEADER = document.querySelector("shopify-section--header");
  const hash = this.hash;
  if (hash !== "#" && hash !== "") {
    e.preventDefault();
    e.stopPropagation();
    const targetElement = document.getElementById(hash.replace("#", ""));

    // ターゲット要素が存在しない場合は処理を終了
    if (!targetElement) {
      console.warn(`Target element with id "${hash.replace("#", "")}" not found`);
      return;
    }

    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.pageYOffset;
    const gap = HEADER ? HEADER.offsetHeight : 0;

    // js-articleToolBar要素が存在するかチェック
    const articleToolBar = document.getElementById("js-articleToolBar");
    const gap2 = articleToolBar ? articleToolBar.offsetHeight : 0;

    const y = rect + offset - gap - gap2;
    window.scroll({
      top: y,
      behavior: "smooth"
    });
  }
}
document.addEventListener("DOMContentLoaded", function() {
  var lazyImages = [].slice.call(document.querySelectorAll("img.lazy-load"));
  if ("IntersectionObserver" in window) {
    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.classList.remove("lazy-load");
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });
    lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  }
});

/**
 * Collapsible functionality extracted from theme.js
 * Provides slide up/down animations for collapsible elements
 */

// Animation utility class
class Animation {
  /**
   * Slide up aims to close an element. To do that, we take the height of the element, and set it to 0 to
   * force an animation
   */
  static slideUp(element) {
    element.style.height = `${element.scrollHeight}px`; // Force previous height to allow CSS transition
    element.offsetHeight; // Force redraw
    element.style.height = 0;
  }

  /**
   * Slide down aims to open an element. To do that, you must make sure that the element you are trying to open
   * is set with height: 0; overflow: hidden in the CSS, and does not contain any padding nor margin.
   */
  static slideDown(element) {
    if (element.style.height === 'auto') {
      return;
    }

    // To do the animation we temporarily hide it, check the height, and transition to it
    element.style.height = `${element.firstElementChild.scrollHeight}px`;

    const transitionEnded = function(event) {
      if (event.propertyName === 'height') {
        element.style.height = 'auto'; // Allows the content to grow normally
        element.removeEventListener('transitionend', transitionEnded);
      }
    };

    element.addEventListener('transitionend', transitionEnded);
  }
}

// DOM utility class
class Dom {
  /**
   * Get all the previous and next siblings, optionally filtered by a selector
   */
  static getSiblings(element, filter, includeSelf = false) {
    const siblings = [];
    let currentElement = element;

    // Do the previous first
    while (currentElement = currentElement.previousElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    if (includeSelf) {
      siblings.push(element);
    }

    // Then the next side
    currentElement = element;
    while (currentElement = currentElement.nextElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    return siblings;
  }
}

// Simple event delegation utility
class EventDelegate {
  constructor(element) {
    this.element = element;
  }

  on(event, selector, handler) {
    this.element.addEventListener(event, (e) => {
      const target = e.target.closest(selector);
      if (target) {
        handler(e, target);
      }
    });
  }
}

// Main Collapsible class
class Collapsible {
  constructor() {
    this.domDelegate = new EventDelegate(document.body);
    this._attachListeners();
  }

  _attachListeners() {
    this.domDelegate.on('click', '[data-action="toggle-collapsible"]', this._toggleCollapsible.bind(this));
  }

  /**
   * Toggle a given collapsible
   */
  _toggleCollapsible(event, target) {
    const parentCollapsible = target.closest('.Collapsible');

    // If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
    if (parentCollapsible.classList.contains('Collapsible--autoExpand') && this._matchesBreakpoint('tablet-and-up')) {
      return;
    }

    const isOpen = target.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      this._close(parentCollapsible, target);
    } else {
      this._open(parentCollapsible, target);
    }

    // We make sure to close any siblings collapsible as well
    Dom.getSiblings(parentCollapsible).forEach((collapsibleToClose) => {
      this._close(collapsibleToClose);
    });

    event.preventDefault();
  }

  /**
   * Open a given collapsible
   */
  _open(collapsible) {
    const toggleButton = collapsible.querySelector('.Collapsible__Button');
    const collapsibleInner = collapsible.querySelector('.Collapsible__Inner');

    if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'true') {
      return; // It's already open
    }

    toggleButton.setAttribute('aria-expanded', 'true');
    collapsibleInner.style.overflow = 'visible';
    Animation.slideDown(collapsibleInner);

    setTimeout(() => {
      collapsible.style.overflow = 'visible';
    }, 350);
  }

  /**
   * Close a given collapsible
   */
  _close(collapsible) {
    const toggleButton = collapsible.querySelector('.Collapsible__Button');
    const collapsibleInner = collapsible.querySelector('.Collapsible__Inner');

    if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'false') {
      return; // It's already closed
    }

    toggleButton.setAttribute('aria-expanded', 'false');
    collapsibleInner.style.overflow = 'hidden';
    collapsible.style.overflow = 'hidden';
    Animation.slideUp(collapsibleInner);
  }

  /**
   * Simple breakpoint matching (you can customize this based on your needs)
   */
  _matchesBreakpoint(breakpoint) {
    const width = window.innerWidth;
    switch (breakpoint) {
      case 'tablet-and-up':
        return width >= 768;
      case 'lap-and-up':
        return width >= 1024;
      case 'desk-and-up':
        return width >= 1200;
      default:
        return false;
    }
  }
}

// Initialize the collapsible functionality
document.addEventListener('DOMContentLoaded', () => {
  new Collapsible();
});

// Export for module usage if needed
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { Collapsible, Animation, Dom, EventDelegate };
}

/**
 * SPの商品カードで、画像に触れている間は2枚目を表示する。
 * タップ操作では既存の商品詳細リンクを維持し、指を離してから1.5秒後に1枚目へ戻す。
 * ブラウザがスクロール操作と判断した場合も、キャンセル後1.5秒は2枚目を維持する。
 */
{
  const ACTIVE_CLASS = 'is-secondary-image-active';
  const RETURN_DELAY_MS = 1500;

  let activeCard = null;
  let activePointerId = null;
  let returnTimer = null;

  const clearReturnTimer = () => {
    if (returnTimer !== null) {
      window.clearTimeout(returnTimer);
      returnTimer = null;
    }
  };

  const resetActiveCard = () => {
    clearReturnTimer();
    activeCard?.classList.remove(ACTIVE_CLASS);
    activeCard = null;
    activePointerId = null;
  };

  const scheduleReset = () => {
    clearReturnTimer();
    returnTimer = window.setTimeout(resetActiveCard, RETURN_DELAY_MS);
  };

  const getTouchedProductCard = (event) => {
    if (event.pointerType !== 'touch') {
      return null;
    }

    const mediaLink = event.target.closest('.product-card__media');
    const productCard = mediaLink?.closest('.product-card');

    if (!productCard?.querySelector('.product-card__image--secondary')) {
      return null;
    }

    return productCard;
  };

  document.addEventListener('pointerdown', (event) => {
    const productCard = getTouchedProductCard(event);

    if (!productCard || activePointerId !== null) {
      return;
    }

    if (activeCard && activeCard !== productCard) {
      resetActiveCard();
    } else {
      clearReturnTimer();
    }

    activeCard = productCard;
    activePointerId = event.pointerId;
    activeCard.classList.add(ACTIVE_CLASS);
  }, { passive: true });

  document.addEventListener('pointerup', (event) => {
    if (event.pointerId !== activePointerId || !activeCard) {
      return;
    }

    activePointerId = null;
    scheduleReset();
  }, { passive: true });

  document.addEventListener('pointercancel', (event) => {
    if (event.pointerId !== activePointerId || !activeCard) {
      return;
    }

    activePointerId = null;
    scheduleReset();
  }, { passive: true });

  window.addEventListener('pagehide', resetActiveCard);
  window.addEventListener('pageshow', resetActiveCard);
}
